<template>
  <v-dialog v-model="show" class="modal" persistent max-width="739px" scrollable>
    <v-card style="align-items: baseline; padding: 0px 32px">
      <v-container class="form-container">
        <v-layout align-center>
          <v-flex>
            <v-card-title primary-title class="pl-0">
              <span class="dialog-title"> {{ $t('register') }} {{ $t('here') }} </span>
            </v-card-title>
          </v-flex>
          <v-flex style="text-align: end">
            <v-btn icon @click="closeDialog">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <sign-up-form @submit="handleSubmit">
          <template #submit-button="{ submit }">
            <main-button
              id="signup"
              depressed
              class="action-button btn-signup"
              :text="$t('registration')"
              @click="submit"
            />
          </template>
        </sign-up-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import SignUpForm from '../../user/sign-up-form.vue'
import { signUp } from '../../../http'
import { LOGIN_NEW_USER_FOR_CHECKOUT } from '../../../graphql/auth.graphql'
import { GET_LOGGED_USER, SIGN_UP } from './../../../graphql/user.graphql'

export default {
  name: 'quick-registration-dialog',
  components: {
    SignUpForm,
  },
  props: {
    show: Boolean,
  },
  methods: {
    async handleSubmit(formData) {
      // TODO: fix error handling issues
      const { errors: signUpErrors } = await signUp(formData)
      if (signUpErrors) {
        this.$emit('errors', {
          open: true,
          messageProp: signUpErrors[0].message,
          color: 'error',
        })

        return
      }

      const { data, errors: loginErrors } = await this.$apollo.mutate({
        mutation: LOGIN_NEW_USER_FOR_CHECKOUT,
        variables: { email: formData.email, password: formData.password },
        refetchQueries: [{ query: GET_LOGGED_USER }],
      })

      if (loginErrors) {
        this.$emit('errors', {
          open: true,
          messageProp: loginErrors[0].message,
          color: 'error',
        })
      } else if (data.loginNewUserForCheckout) {
        this.$emit('success')
        this.closeDialog()
      }
    },
    closeDialog() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
.action-button {
  height: 36px !important;
}

.form-container {
  padding: 0px;
}

.dialog-title {
  font-family: Raleway, 'sans-serif';
  color: #0277bd;
  font-size: 24px;
  text-transform: unset;
}

.btn-row {
  padding: 0;
  justify-content: space-between;
  padding-bottom: 24px;
}
</style>
